export interface CatalogOption {
  id: string;
  label: string;
}

export const SIGNAL_OPTIONS: CatalogOption[] = [
  { id: 'revenue_growth_yoy', label: 'Revenue Growth' },
  { id: 'eps_growth_yoy', label: 'EPS Growth' },
  { id: 'gross_margin', label: 'Gross Margin' },
  { id: 'operating_margin', label: 'Operating Margin' },
  { id: 'net_margin', label: 'Net Margin' },
  { id: 'free_cash_flow', label: 'Free Cash Flow' },
  { id: 'roe', label: 'ROE' },
  { id: 'roa', label: 'ROA' },
  { id: 'debt_to_equity', label: 'Debt to Equity' }
];

export const THEME_OPTIONS: CatalogOption[] = [
  { id: 'technology', label: 'Technology' },
  { id: 'financial_services', label: 'Financial Services' },
  { id: 'healthcare', label: 'Healthcare' },
  { id: 'real_estate', label: 'Real Estate' },
  { id: 'consumer_cyclical', label: 'Consumer cyclical' },
  { id: 'energy', label: 'Energy' },
  { id: 'industrials', label: 'Industrials' },
  { id: 'communication_services', label: 'Communication Services' },
  { id: 'utilities', label: 'Utilities' },
  { id: 'basic_materials', label: 'Basic Materials' },
  { id: 'consumer_defensive', label: 'Consumer Defensive' },
];

export const INVESTING_STYLE_OPTIONS: Array<{
  id: import('../types').InvestingStyleId;
  label: string;
  description: string;
  iconName: 'growth' | 'value' | 'compounder' | 'dividend' | 'founder' | 'unsure';
}> = [
  {
    id: 'growth',
    label: 'High-Growth',
    description: 'Companies with high earnings growth potential',
    iconName: 'growth',
  },
  {
    id: 'steady_compounder',
    label: 'Steady Compounders',
    description: 'Companies with steady high quality growth',
    iconName: 'compounder',
  },
  {
    id: 'value',
    label: 'Deep Value',
    description: 'Companies trading below intrinsic value',
    iconName: 'value',
  },
  {
    id: 'dividend',
    label: 'Dividend Payers',
    description: 'Strong dividend payers with income',
    iconName: 'dividend',
  },
  {
    id: 'founder_led',
    label: 'Founder-led Operators',
    description: 'Led by founder operators',
    iconName: 'founder',
  },
];

export const ALL_SIGNAL_IDS = SIGNAL_OPTIONS.map((option) => option.id);

export const ALL_THEME_IDS = THEME_OPTIONS.map((t) => t.id);
